import { useQuery } from '@tanstack/react-query';
import { getPlatformFeatures, PlatformFeatureDto } from '../api/platformApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { platformKeys } from './usePlatformOrganisations';

export function usePlatformFeatures(searchTerm?: string) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: [...platformKeys.all, 'features', searchTerm ?? ''] as const,
    queryFn: async (): Promise<PlatformFeatureDto[]> => {
      const result = await getPlatformFeatures(searchTerm);
      return result?.features ?? [];
    },
    placeholderData: previousData => previousData,
    enabled: isAuthenticated,
  });
}
